import React, { memo, useEffect, useState } from "react";
import clsx from "clsx";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import Videocam from "@material-ui/icons/Videocam";
import VideocamOff from "@material-ui/icons/VideocamOff";

import useLocalVideoToggle from "../../../../../twilio/hooks/useLocalVideoToggle/useLocalVideoToggle";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { setisVideoEnabled } from "../../../../../store/features/audioVideoControl/audioVideoControl";

interface IToggleVideoButtonProps {
  disabled?: boolean;
  className?: string;
  activeClassName?: string;
  isConnected?: boolean
}

const ToggleVideoButton = ({
  disabled,
  className,
  activeClassName,
  isConnected
}: IToggleVideoButtonProps): JSX.Element => {
  const [isVideoEnabled, toggleVideoEnabled, shouldHideBtn] = useLocalVideoToggle();
  const dispatch = useAppDispatch();
  const isVideoEnabledDefault = useAppSelector(state => state.audioVideoControl.isVideoEnabled);
  const [isVideoEnabledDefaultState, setisVideoEnabledDefaultState] = useState(isVideoEnabledDefault);

  useEffect(() => {
    if (isConnected) {
      if (isVideoEnabledDefaultState !== isVideoEnabled) {
        toggleVideoEnabled();
      }
    }
    return () => {
    };
  }, [isConnected]);

  if (shouldHideBtn) {
    return null;
  }

  return (
    <Tooltip
      title={isVideoEnabled ? "Disable Video" : "Enable Video"}
      placement="top"
      PopperProps={{ disablePortal: true }}
    >
      <Fab
        className={clsx(className, { [activeClassName]: isVideoEnabled })}
        onClick={()=>{
          toggleVideoEnabled();
          dispatch(setisVideoEnabled(!isVideoEnabledDefault));
        }}
        onContextMenu={() => {
        }}
        disabled={disabled}
      >
        {isVideoEnabled ? <Videocam /> : <VideocamOff />}
      </Fab>
    </Tooltip>
  );
};

export default memo(ToggleVideoButton);
